export interface Result{
  firstWarning: number;
  secondWarning: number;
  deprivedFlag: number;
  type: string,
  possibleCombinations: {lectures: number, tutorials: number}[]
}

export const calculateAbsense = (courseID: string, credits: number, missedLecs: number, missedTuts: number): Result => {
  const result: Result = {
    firstWarning: 0,
    secondWarning: 0,
    deprivedFlag: 0,
    type: 'normal',
    possibleCombinations: Array(7).fill({}).map(() => ({ lectures: -1, tutorials: -1 }))
  };

  const OddGENsCourses = ["GEN341","GEN342","GEN004","GEN333", "GENS442", "GENS341"];
  const noAbsenceCourses = ["481","482","281","381", "480"];

  let CurrentPoints, LecsPoints, TutsPoints, j=0;

  const courseCode = courseID.slice(0,3);
  const courseNumber = courseID.slice(4,7);
  const course = courseCode + courseNumber;

  //======Case 0======:
  if (noAbsenceCourses.includes(courseNumber)){
    result.type = 'gradOrIT'
    return result ;
  }

  else if (credits === 4){
    result.type = '4crds'
    return result ;
  }

  //======Case 1======:
  else if ((credits === 1 || (credits===2 && courseCode === "GEN") || (courseCode === "CMP" && courseNumber === "111")) 
    && !OddGENsCourses.includes(course)){
    //Core Algorithm
    if (missedLecs >=4 ) result.possibleCombinations[0].lectures = -1;
    else result.possibleCombinations[0].lectures = 3 - missedLecs;

    //Return
    if (result.possibleCombinations[0].lectures >= 0){
      if (result.possibleCombinations[0].lectures === 1){
        result.firstWarning = 1;
        result.secondWarning = 0;
      }
      else if (result.possibleCombinations[0].lectures === 0){
        result.firstWarning = 0;
        result.secondWarning = 1;
      }
    }
    else result.deprivedFlag = 1;
    return result;
  }

  //======Case 2 & 3======: Common logic for 2 and 3 credit courses
  else if ((credits === 2 && courseCode !== "GEN") || OddGENsCourses.includes(course) || credits === 3){
    // Set total points based on credits
    const totalPoints = credits === 3 ? 10 : 6;
    const firstWarningThreshold = credits === 3 ? 4 : 2;
    const secondWarningLowerBound = credits === 3 ? 2 : 1;
    
    //Core Algorithm
    CurrentPoints = totalPoints - (2 * missedLecs + 1 * missedTuts);
    
    for (let i = 0; i <= CurrentPoints; i++) {
      LecsPoints = CurrentPoints - i;
      TutsPoints = i;
      if (LecsPoints % 2 === 0) {
        result.possibleCombinations[j].lectures = LecsPoints / 2;
        result.possibleCombinations[j].tutorials = TutsPoints / 1;
        j = j + 1;
      }
    }

    // Set warnings based on current points
    if (CurrentPoints >= 0) {
      if (CurrentPoints <= firstWarningThreshold && CurrentPoints > secondWarningLowerBound) {
        result.firstWarning = 1;
        result.secondWarning = 0;
      }
      else if (CurrentPoints <= secondWarningLowerBound && CurrentPoints >= 0) {
        result.firstWarning = 0;
        result.secondWarning = 1;
      }
    }
    else {
      result.deprivedFlag = 1;
    }
    return result;
  }


  else {
    return result;
  }
} 